__webpack_require__.p = "/whats-included-in-us-gdp-set-2/";